<ng-container *ngIf="!noAgents">
  <lms-toolbar [options]="toolbarConfig">
    <div class="lms-toolbar__item" *lmsProfileGuard="'agents.create'" tools-actions>
      <gl-button
        color-primary
        icon-left="glicon-user-plus"
        title="{{ 'agents.create' | translate }}"
        [text]="'agents.create' | translate"
        [routerLink]="['/agents/new']"
        [queryParams]="{ clientId: client.id }"
      >
      </gl-button>
    </div>
  </lms-toolbar>

  <lms-agents-list
    [listId]="listId"
    [options]="{
      disabledColumns: ['clientIds'],
      filters: { clientIds: client.id }
    }"
  ></lms-agents-list>
</ng-container>

<!-- client without agents -->
<div *ngIf="noAgents">
  <div class="main__void">
    <div class="main__void--icon">
      <span class="glicon-admins"></span>
    </div>
    <span class="main__void--title">{{ 'agents.noAgents' | translate }}</span>
    <span class="main__void--subtitle">{{ 'agents.noAgentsSubTitle' | translate }}</span>
    <div *lmsProfileGuard="'agents.create'">
      <gl-button
        color-primary
        icon-left="glicon-user-plus"
        title="{{ 'agents.create' | translate }}"
        [text]="'agents.create' | translate"
        [routerLink]="['/agents/new']"
        [queryParams]="{ clientId: client.id }"
      >
      </gl-button>
    </div>
  </div>
</div>
